var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thumbs-down"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99905 15.0001V19.0001C9.99905 19.7958 10.3151 20.5588 10.8777 21.1214C11.4403 21.684 12.2034 22.0001 12.9991 22.0001L16.9991 13.0001V2.00012H5.71905C5.23673 1.99466 4.76868 2.16371 4.40115 2.47611C4.03362 2.78851 3.79138 3.22321 3.71905 3.70012L2.33905 12.7001C2.29555 12.9868 2.31488 13.2794 2.39571 13.5579C2.47655 13.8363 2.61695 14.0938 2.8072 14.3126C2.99744 14.5314 3.23297 14.7062 3.49748 14.8249C3.76199 14.9436 4.04915 15.0034 4.33905 15.0001H9.99905ZM16.9991 2.00012H19.6691C20.235 1.99011 20.785 2.18825 21.2145 2.55694C21.644 2.92562 21.9232 3.43918 21.9991 4.00012V11.0001C21.9232 11.5611 21.644 12.0746 21.2145 12.4433C20.785 12.812 20.235 13.0101 19.6691 13.0001H16.9991",
    fill: "#862B23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9991 13.0001L12.9991 22.0001C12.2034 22.0001 11.4403 21.684 10.8777 21.1214C10.3151 20.5588 9.99905 19.7958 9.99905 19.0001V15.0001H4.33905C4.04915 15.0034 3.76199 14.9436 3.49748 14.8249C3.23297 14.7062 2.99744 14.5314 2.8072 14.3126C2.61695 14.0938 2.47655 13.8363 2.39571 13.5579C2.31488 13.2794 2.29555 12.9868 2.33905 12.7001L3.71905 3.70012C3.79138 3.22321 4.03362 2.78851 4.40115 2.47611C4.76868 2.16371 5.23673 1.99466 5.71905 2.00012H16.9991M16.9991 13.0001V2.00012M16.9991 13.0001H19.6691C20.235 13.0101 20.785 12.812 21.2145 12.4433C21.644 12.0746 21.9232 11.5611 21.9991 11.0001V4.00012C21.9232 3.43918 21.644 2.92562 21.2145 2.55694C20.785 2.18825 20.235 1.99011 19.6691 2.00012H16.9991",
    stroke: "#601009",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbsDown.ec5efee1d4fee75ed3d6cb31e9b41da4.svg";
export { ForwardRef as ReactComponent };